var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","href":"https://www.instagram.com/bayhousegrenada/","target":"_blank"}},[_c('v-icon',{attrs:{"size":"50"}},[_vm._v(" mdi-instagram ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }